import { render } from "./Analytical_Dashboards.vue?vue&type=template&id=b380e952&scoped=true"
import script from "./Analytical_Dashboards?vue&type=script&lang=js"
export * from "./Analytical_Dashboards?vue&type=script&lang=js"

import "./Analytical_Dashboards.vue?vue&type=style&index=0&id=b380e952&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b380e952"]])

export default __exports__